import styled from 'styled-components'

export const ShowFunctionWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  & > div {
    flex: 1;
  }

  & > div:first-child {
    margin-right: 16px;
    width: 50%;
  }
`
